import * as React from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { TableHead } from './table';
import { SortDirection } from '../../hooks/useTableSort';

interface SortableTableHeadProps<F extends string> {
    field: F;
    label: React.ReactNode;
    sortField: string | null;
    sortDirection: SortDirection;
    onToggle: (field: F) => void;
    className?: string;
}

export function SortableTableHead<F extends string>({
    field,
    label,
    sortField,
    sortDirection,
    onToggle,
    className,
}: SortableTableHeadProps<F>) {
    return (
        <TableHead className={className}>
            <button
                type="button"
                className="-ml-1 flex items-center gap-1.5 rounded px-1 py-0.5 text-left uppercase tracking-wider hover:text-foreground"
                onClick={() => onToggle(field)}
            >
                {label}
                {sortField === field ? (
                    sortDirection === 'asc' ? (
                        <ArrowUp className="h-3.5 w-3.5 shrink-0" />
                    ) : (
                        <ArrowDown className="h-3.5 w-3.5 shrink-0" />
                    )
                ) : (
                    <ArrowUpDown className="h-3.5 w-3.5 shrink-0 opacity-40" />
                )}
            </button>
        </TableHead>
    );
}
